"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitExceededNotificationCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../commands");
const components_1 = require("../components");
const CardHelper_1 = require("../utils/CardHelper");
const LimitExceededNotificationCard = (applicationType, notificationType, usage, limit, warning, hasSubscription, trialDays) => {
    const card = CardHelper_1.CardHelper.newCard();
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    card.addItem(container);
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: getNotificationTitle(notificationType),
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    const usageMeter = (0, components_1.UsageMeter)(applicationType, usage, limit, warning);
    container.addItem(usageMeter);
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: getNotificationDescription(notificationType, limit, trialDays, false),
        wrap: true,
    }));
    card.addAction((0, commands_1.DeleteCardAction)());
    if (!hasSubscription) {
        card.addAction((0, commands_1.BuyPlanAction)(notificationType, "🔗 Subscribe"));
        card.addAction((0, commands_1.StartTrialAction)(notificationType, "🔗 Start Trial"));
    }
    else {
        card.addAction((0, commands_1.UpgradePlanAction)("🔗 Upgrade Plan"));
    }
    return card;
};
exports.LimitExceededNotificationCard = LimitExceededNotificationCard;
const getNotificationTitle = (notificationType) => {
    switch (notificationType) {
        case "notify-response-limit-warning":
            return "You are nearing your plan limit";
        case "notify-response-limit-exceeded":
            return "You've reached a plan limit";
        default:
            throw new Error(`Unexpected notification type: ${notificationType}`);
    }
};
const getNotificationDescription = (notificationType, limit, trialDays, isPaidUser) => {
    if (isPaidUser) {
        switch (notificationType) {
            case "notify-response-limit-warning":
                return `Your current plan includes ${limit} responses. If you exceed the limit you will need to upgrade your plan for more responses.`;
            case "notify-response-limit-exceeded":
                return `Your current plan includes ${limit} responses. To continue please upgrade your plan for more responses.`;
            default:
                throw new Error(`Unexpected notification type: ${notificationType}`);
        }
    }
    else {
        switch (notificationType) {
            case "notify-response-limit-warning":
                return `The free plan includes ${limit} responses. If you exceed the limit you will need to upgrade your plan to continue. To help you decide if a higher plan is right for you, Polly is also offering a free ${trialDays} day trial.`;
            case "notify-response-limit-exceeded":
                return `The free plan includes ${limit} responses. To continue please upgrade your plan. To help you decide if a higher plan is right for you, Polly is also offering a free ${trialDays} day trial.`;
            default:
                throw new Error(`Unexpected notification type: ${notificationType}`);
        }
    }
};
//# sourceMappingURL=LimitExceededNotificationCard.js.map